import { OrganizationSelectorContainer } from "./container";

export const OrganizationSelector = (props: { navigateToRoot: () => void }) => {
  const { navigateToRoot } = props;
  return <OrganizationSelectorContainer navigateToRoot={navigateToRoot} />;
};
